<div class="zest-card" *ngIf="application">
  <div class="row white-row row-height-32px margin-bottom-0px">
    <div class="col s10 offset-s1">
      <div class="row margin-bottom-0px">
        <div class="col s7 row-label" [textContent]="'Order amount'"></div>
        <div class="col s5 row-label currency text-right" [textContent]="(application.BasketAmount | RupeeCurrencyPipe)"></div>
      </div>
    </div>
  </div>
  <div class="line2"></div>
  <div class="row white-row row-height-42px margin-bottom-0px">
    <div class="col s10 offset-s1">
      <div class="row margin-bottom-0px">
        <div class="col s7 row-label" [textContent]="'EMI Plan'"></div>
        <div class="col s5 row-label currency text-right" *ngIf="!emiOption" [textContent]="(application.TotalInstallmentAmount | RupeeCurrencyPipe) + '/mo'"></div>
        <div class="col s5 row-label currency text-right" *ngIf="emiOption" [textContent]="(emiOption.TotalMonthlyAmount | RupeeCurrencyPipe) + '/mo'"></div>
        <div class="col s7 row-disclaimer currency" [textContent]="'Inclusive Of Interest'"></div>
        <div class="col s5 row-disclaimer currency text-right" *ngIf="!emiOption" [textContent]="application.NumberOfInstallments + ' months'"></div>
        <div class="col s5 row-disclaimer currency text-right" *ngIf="emiOption" [textContent]="emiOption.NumberOfMonths + ' months'"></div>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <div class="row white-row row-height-54px margin-bottom-0px">
    <div class="col s10 offset-s1">
      <div class="row margin-bottom-0px">
        <div class="col s7 row-label text-bold" [textContent]="'Pay Now'"></div>
        <div class="col s5 row-amount currency text-bold text-right" *ngIf="!application.IsDPMade && (application.InitialPaymentAmount < 1)"
          [textContent]="((application.DownpaymentAmount + application.ProcessingFee) | RupeeCurrencyPipe)"></div>
        <div class="col s5 row-amount currency text-bold text-right" *ngIf="application.IsDPMade || (!application.IsDPMade && (application.InitialPaymentAmount > 0))"
          [textContent]="(application.InitialPaymentAmount | RupeeCurrencyPipe)"></div>
        <div class="col s12 row-disclaimer row-amount-offset-bottom">
          <span class="currency" [textContent]="'Downpayment (' + (application.DownpaymentAmount | RupeeCurrencyPipe) + ')'"></span>
          <br/>
          <span class="currency" [textContent]="'+ Processing fee (' + (application.ProcessingFee | RupeeCurrencyPipe) + ')'"></span>
        </div>
      </div>
    </div>
  </div>
</div>